<template>
  <footer>
    <v-row class="copyright_wrap">
      <div class="copyright_inner">
        <v-col class="footer_icon d-flex align-center">
          <v-img style="max-width:63px; cursor:pointer;" src="~@/assets/img/footer_icon01.png" @click="fnGoURL(koicaHomePage)" alt="KOICA HOMEPAGE" title="KOICA HOMEPAGE" />
          <v-spacer class="hidden_lr5"></v-spacer>
          <v-img style="" src="~@/assets/img/bar.png"></v-img>
          <v-img style="max-width:69px;" src="~@/assets/img/footer_icon02.png" alt="WORLD FRIENDS KOREA" title="WORLD FRIENDS KOREA" />
        </v-col>
        <v-col class="copy__text">
          <p class="mail__to">
            <a href="mailto:egpohelpdesk@egypo.gov.eg">
              <strong>{{$t('footer.email_info')}}</strong>
              <v-spacer class="hidden_lr10"/>
              <v-icon color="#a01c2a">mdi-email</v-icon>
              <v-spacer class="hidden_lr5"/>
              egpohelpdesk@egypo.gov.eg
            </a>
          </p>
          <p>This system has been implemented by the grant of the government of the Republic of Korea.</p>
          <p style="display:flex;"><i>Copyright  ⓒ 2020 Siriussoft Co</i><i>.,</i> <i>Ltd. All Rights Reserved</i><i>.</i></p>
        </v-col>
        <v-col class="footer_text_icon d-flex align-center">
          <div class="ft__text__icon cursor_pointer" tabindex="0" @click="fnGoURL(searchHomePage)">
            SEARCH<br>SYSTEM
          </div>
          <div class="ft__text__icon cursor_pointer" tabindex="0" @click="fnGoURL(egpoHomePage)">
            EGPO<br>HOMEPAGE
          </div>
        </v-col>
      </div>
    </v-row>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  components: {
  },
  data() {
    return {
      searchString: '',
      koicaHomePage: process.env.VUE_APP_KOICA_HOME,
      egpoHomePage: process.env.VUE_APP_EGPO_HOME,
      searchHomePage: process.env.VUE_APP_SEARCH_HOME
    };
  },
  mounted() {

  },
  methods: {
    fnGoURL(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
